import { render, staticRenderFns } from "./index.vue?vue&type=template&id=50232ed4"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=50232ed4&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/31ddae26-918c-4c5a-957f-539a4cbf5f74/workspace/streffy-middle-office_CyFO/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50232ed4')) {
      api.createRecord('50232ed4', component.options)
    } else {
      api.reload('50232ed4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=50232ed4", function () {
      api.rerender('50232ed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/basic-layout/header-notice/index.vue"
export default component.exports